import ReactDOM from 'react-dom';

import App from 'App';

import 'shared/config/date';

import 'index.css';

ReactDOM.render(<App />, document.getElementById('root'));
